import { SIGNATURE_LIMITS } from '@demandproai/shared';
import UploadButtonGroup from '../../../../components/common/UploadButtonGroup';
import FileUploadIcon from '../../../../assets/icons/upload_file.svg?react';
import UploadIcon from '../../../../assets/icons/icon_upload.svg?react';
import { baseClasses, variantClasses } from '../../../../components/common/primitiveClasses';
import { spinnerClasses } from '../../../../components/common/loaderClasses';
import { cn } from '../../../../utils/classNames';

export const SIGNATURE_UPLOAD_INPUT_ID = 'signature-upload-input';

const dropzoneClasses =
  'border-2 border-dashed border-border rounded-lg p-10 text-center text-disabled ' +
  'transition-colors duration-300 ease-in-out';

const iconWrapperClasses = 'mb-6 flex justify-center text-[calc(var(--spacing)*16)] text-subtle';

const messageClasses = 'text-base text-subtle mb-6';

const uploadGroupClasses = 'justify-center';

const inputClasses = 'hidden';

const SignatureDropzone = ({ message, disabled, onFileSelect }) => (
  <div className={dropzoneClasses}>
    <div className={iconWrapperClasses}>
      <FileUploadIcon />
    </div>
    <p className={messageClasses}>{message}</p>
    <UploadButtonGroup
      accept={SIGNATURE_LIMITS.MIME_TYPE}
      multiple={false}
      disabled={disabled}
      isLoading={disabled}
      onFileSelect={onFileSelect}
      className={uploadGroupClasses}
      inputProps={{ id: SIGNATURE_UPLOAD_INPUT_ID, className: inputClasses }}
      renderUploadButton={({ disabled: isDisabled, isLoading }) => (
        <label
          htmlFor={SIGNATURE_UPLOAD_INPUT_ID}
          className={cn(
            baseClasses,
            variantClasses.outlinePrimary,
            'mx-auto!',
            isDisabled && 'opacity-50 pointer-events-none'
          )}
          aria-disabled={isDisabled || undefined}
        >
          {isLoading ? (
            <span className={spinnerClasses} role="status" aria-label="Uploading" />
          ) : (
            <>
              <UploadIcon className="text-primary" />
              Upload
            </>
          )}
        </label>
      )}
    />
  </div>
);

export default SignatureDropzone;
